import { Typography, Box, useTheme } from '@mui/material';

import { NewAnnotationCard } from '../EditAndAddAnnotations/NewAnnotationCard';

interface ReplaceConflictWithAnnotationCardProps {
  conceptId: string;
  conflictId: string;
}
export const ReplaceConflictWithAnnotationCard = ({
  conceptId,
  conflictId,
}: ReplaceConflictWithAnnotationCardProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ border: `1px solid ${theme.palette.grey[200]}` }}>
      <NewAnnotationCard conceptId={conceptId} conflictId={conflictId} />
    </Box>
  );
};
